import { completeFile, createFile, uploadInfo as getUploadInfo, createAutoProgram } from '@/services/saas/fileInfo';
// import AliyunUpload from 'AliyunUpload';

const PlatformType = {
  ali: 'ali',
  mbs: 'mbs',
};

const UserData = '{"Vod":{}}';

export default class FileUploader {
  programId = undefined;
  platformType = undefined;
  
  fileInfos = {};
  mbsUploader = {};
  aliUpload = {};

  aliOptions = {
    timeout: '',
    partSize: '',
    parallel: '',
    retryCount: '',
    retryDuration: '',
    region: 'cn-shanghai',
    userId: '1303984639806000',
}

  constructor({ platformType, deptId }) {
    if (platformType && deptId) {
      this.platformType = platformType;
      this.createProgram(platformType, deptId);
    }
  }

  getProgramId = () => {
    return this.programId;
  }

  createProgram = async (platformType, deptId) => {
    const resp = await createAutoProgram({
      platformType,
      orgId: deptId,
    });
    if (resp && resp.success) {
      this.programId = resp.data.programId;
    }
  };

  createFile = async (file, { fileType }) => {
    const fileExt = file.name.slice(file.name.lastIndexOf('.') + 1).toLowerCase();
    const fileName = file.name.slice(0, file.name.lastIndexOf('.'));
    const response = await createFile({
      fileExt,
      fileName,
      fileType,
      programId: this.programId,
    });
    if (response.success) {
      return response.data;
    }
  };

  uploadFile = async (file, { fileType }) => {
    this.handleUploadProgress(0);
    if (this.platformType === PlatformType.mbs) {
      this.uploadMbsFile(file, { fileType });
    }
    if (this.platformType === PlatformType.ali) {
      this.uploadAliFile(file, { fileType });
    }
  }

  uploadMbsFile = async (file, { fileType }) => {
    if (this.programId && file) {
      const data = await this.createFile(file, { fileType });
      if (data) {
        this.fileInfos = data;
        const { uploadInfo: { url } } = data;
        const formData = new FormData();
        formData.append('file', file);
        this.handleMbsUpload(url, formData, {});
      }
    }
  };

  handleMbsUpload = (url, params, headers = {}) => {
    const xhr = new XMLHttpRequest();
    this.mbsUploader = xhr;
    xhr.open('post', url);
    Object.keys({ ...headers }).forEach(item => {
      xhr.setRequestHeader(item, headers[item]);
    });
    xhr.onreadystatechange = async () => {
      if (xhr.readyState === 4 && xhr.status === 200) {
        await this.handleComplete();
        this.handleUploadComplete(this.fileInfos);
      }
    };
    if (xhr.upload){
        xhr.upload.onprogress = e => {
          var percent = Math.floor( e.loaded / e.total * 100);
          this.handleUploadProgress(percent);
        }
    }
    xhr.onerror = this.handleUploadError;
    xhr.send(params);
  };

  uploadAliFile = async (file, { fileType }) => {
    this.aliUpload = this.handleAliUpload(file, { fileType });
    this.aliUpload.addFile(file, null, null, null, UserData);
    this.aliUpload.startUpload();
  }
  
  handleAliUpload = (file, { fileType }) => {
    
    const _uploader = new window.AliyunUpload.Vod({
      timeout: this.aliOptions.timeout || 60000,
      // 分片大小默认1M，不能小于100K
      partSize: this.aliOptions.partSize || 1048576,
      // 并行上传分片个数，默认5
      parallel: this.aliOptions.parallel || 5,
      // 网络原因失败时，重新上传次数，默认为3
      retryCount: this.aliOptions.retryCount || 3,
      // 网络原因失败时，重新上传间隔时间，默认为2秒
      retryDuration: this.aliOptions.retryDuration || 2,
      // 上传到点播的地域， 默认值为'cn-shanghai',//eu-central-1,ap-southeast-1
      region: this.aliOptions.region,
      // 阿里账号ID，必须有值 ，值的来源https://help.aliyun.com/knowledge_detail/37196.html
      userId: this.aliOptions.userId,
      addFileSuccess: uploadInfo => {
         console.log('添加文件成功, 等待上传...');
      },
      onUploadstarted: async uploadInfo => {
          console.log('===========文件上传开始===========');
          console.log(uploadInfo);
          const data = await this.createFile(file, { fileType });
          if (data) {
            this.fileInfos = data;
            const { uploadInfo: { UploadAuth: uploadAuth, UploadAddress: uploadAddress, VideoId, ImageURL } } = data;
            if (fileType === '1' || fileType === '5'){
              _uploader.setUploadAuthAndAddress(uploadInfo, uploadAuth, uploadAddress, VideoId);              
            } else if (fileType === '3') {
              _uploader.setUploadAuthAndAddress(uploadInfo, uploadAuth, uploadAddress, ImageURL);
            }
          }
      },
      onUploadSucceed: async (uploadInfo) => {
          console.log('文件上传成功');
      },
      onUploadFailed: (uploadInfo, code, msg) => {
          console.log('文件上传失败');
          this.handleUploadError();
      },
      onUploadCanceled: (uploadInfo, code, msg) => {
          console.log('文件已暂停上传');
      },
      onUploadProgress: (uploadInfo, totalSize, progress) => {
          const progressPercent = Math.floor(progress * 100);
          this.handleUploadProgress(progressPercent);
      },
      onUploadTokenExpired: async (uploadInfo) => {
        this.handleAliTokenExpired(fileType, uploadInfo);
      },
      onUploadEnd: async (uploadInfo) => {
        console.log('文件上传完毕');
        await this.handleComplete();
        this.handleUploadComplete(this.fileInfos);
      }
    });
    return _uploader;
  }

  handleAliTokenExpired = async (fileType, uploadInfo) => {
    if (fileType === '1' || fileType === '5'){
      if (uploadInfo.videoId) {
        const { fileInfoId } = this.fileInfos
        const response = await getUploadInfo(fileInfoId);
        if (response.success) {
          const { UploadAuth } = response.data;
          this.aliUpload.resumeUploadWithAuth(UploadAuth);
        }
      }
    }
  }

  handleComplete = async () => {
    const { fileInfoId } = this.fileInfos;
    const resp = await completeFile(fileInfoId);
    if (resp.success) {
      console.log('上传成功');
      // message.success("上传成功");
    }
  }

  handleUploadProgress = () => {}

  handleUploadError = () => {}

  handleUploadComplete = () => {}
}
